








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Message extends Vue {
  @Prop({ type: String, required: true })
  readonly color!: string;

  get statusColorClass() {
    const { color } = this;
    return `message_${color}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/purchases/components/message/Message.vue